export const sampleTrailers = [
  {
    id: 1,
    year: 2024,
    make: 'Big Tex',
    model: '70SR-10',
    vehicle_type: 'trailer',
    vehicleType: 'trailer',
    type: 'Utility Trailer',
    condition: 'new',
    price: 2499,
    length: 12,
    width: 6.5,
    capacity: 2990,
    axles: 1,
    description: 'Single axle utility trailer perfect for hauling equipment, ATVs, or general cargo. Features treated wood floor and LED lights.',
    features: [
      'LED Lighting',
      'Treated Wood Floor',
      'Fold-Down Ramp Gate',
      'Safety Chains',
      'Spare Tire Mount',
      'D-Ring Tie Downs'
    ],
    image: 'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=800',
    images: [
      'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=800',
      'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800'
    ],
    available: true,
    status: 'on-lot'
  },
  {
    id: 2,
    year: 2024,
    make: 'PJ Trailers',
    model: 'DL14',
    vehicle_type: 'trailer',
    vehicleType: 'trailer',
    type: 'Dump Trailer',
    condition: 'new',
    price: 8999,
    length: 14,
    width: 7,
    capacity: 14000,
    axles: 2,
    description: 'Heavy-duty tandem axle dump trailer with hydraulic lift. Perfect for construction, landscaping, and heavy hauling.',
    features: [
      'Hydraulic Dump System',
      'Tandem 7000lb Axles',
      'Electric Brakes',
      'Battery Charger',
      'Ramps Included',
      'Tarp Kit Ready',
      'Remote Control'
    ],
    image: 'https://images.unsplash.com/photo-1558879518-b8b0e1f27d0f?w=800',
    images: [
      'https://images.unsplash.com/photo-1558879518-b8b0e1f27d0f?w=800',
      'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=800'
    ],
    available: true,
    status: 'on-lot'
  },
  {
    id: 3,
    year: 2023,
    make: 'Pace American',
    model: 'Journey SE',
    vehicle_type: 'trailer',
    vehicleType: 'trailer',
    type: 'Enclosed Trailer',
    condition: 'used',
    price: 4500,
    length: 16,
    width: 7,
    capacity: 7000,
    axles: 2,
    description: 'Lightly used enclosed cargo trailer. Great for moving, storage, or converting to mobile workshop.',
    features: [
      'Side Door Access',
      'Rear Ramp Door',
      'Interior Lighting',
      'E-Track System',
      'Roof Vent',
      'Wall Vents'
    ],
    image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
    images: [
      'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800',
      'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=800'
    ],
    available: true,
    status: 'on-lot'
  }
];

export default sampleTrailers;
